/* eslint-disable camelcase */

export default api => {
  function getRequests(query) {
    return api.get(`/_svc/slapi-v1/stocks/requests?${query}`);
  }

  function createPicklist(payload) {
    return api.post(`/_svc/slapi-v1/stocks/picklist/create`, payload);
  }

  function getPicklists(query) {
    return api.get(`/_svc/slapi-v1/stocks/picklists?${query}`);
  }

  function getPicklistItems(query) {
    return api.get(`/_svc/slapi-v1/stocks/picklist/items?${query}`);
  }

  function markReadyForPickup(payload) {
    return api.post(`/_svc/slapi-v1/stocks/move/readyforpickup`, payload);
  }

  function updatePicklistQty(payload) {
    return api.post(`/_svc/slapi-v1/stocks/picklist/reduce`, payload);
  }

  function getReadyForPickup(query) {
    return api.get(`/_svc/slapi-v1/stocks/readyforpick/items?${query}`);
  }

  function getStocksCount(query) {
    return api.get(`/_svc/slapi-v1/stocks/count?${query}`);
  }

  function markOutOfStock(payload) {
    return api.post(`/_svc/slapi-v1/stocks/requests/oos`, payload);
  }

  return {
    getRequests,
    createPicklist,
    getPicklists,
    getPicklistItems,
    markReadyForPickup,
    getReadyForPickup,
    updatePicklistQty,
    getStocksCount,
    markOutOfStock
  };
};



// WEBPACK FOOTER //
// ./src/services/StockRequestService.js